import { render, staticRenderFns } from "./chunkStudentResult.vue?vue&type=template&id=3b7e2845&"
import script from "./chunkStudentResult.vue?vue&type=script&lang=js&"
export * from "./chunkStudentResult.vue?vue&type=script&lang=js&"
import style0 from "./chunkStudentResult.vue?vue&type=style&index=0&id=3b7e2845&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports